import { useQuery } from "@apollo/client/react";

import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import useErrorHandle from "hooks/useErrorHandle";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";

import { StackContext } from "../Context";
import { GET_STACK_HOOKS } from "./gql";
import StackHooksContent from "./Content";

const StackHooks = () => {
  const { stack } = useTypedContext(StackContext);

  useTitle(`Hooks · ${stack.name}`);

  const { data, loading, error } = useQuery(GET_STACK_HOOKS, {
    variables: {
      id: stack.id,
    },
    fetchPolicy: "no-cache",
  });

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (loading && !data?.stack) {
    return <PageLoading />;
  }

  if (!data?.stack) {
    return <NotFoundPage />;
  }

  return <StackHooksContent stackWithHooks={data.stack} />;
};

export default StackHooks;
